import { createContext } from "react";

// Jds 02/11: na tela de conversas (computador) a barra roxa sai e os botões dela
// vão para o topo da coluna da esquerda. O layout entrega aqui a faixa pronta.
export const BarraContext = createContext({ semBarra: false, barra: null });
